import React from 'react';

function Underline() {
  return (
    <div className='bg-pink-500 block h-1.5 mt-5 mx-20 rounded-full'></div>
  );
}

export default Underline;
